import React, { useEffect } from "react";
import { Modal, Table, Button, Space } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { getClientFailedShares } from "../../redux/actions/clientFailedSharesActions";
import dateUtils from "../../utils/dateUtils";

interface InvoiceConfirmationModalProps {
    visible: boolean;
    onCancel: () => void;
    onProcess: () => void;
    clientId: string;
}

const InvoiceConfirmationModal: React.FC<InvoiceConfirmationModalProps> = ({
    visible,
    onCancel,
    onProcess,
    clientId,
}) => {
    const dispatch = useDispatch();
    const { failedShares, pending } = useSelector(
        (state: RootState) => state.clientFailedShares,
    );

    // Note: The parent component (ClapIncomes) handles the API call
    // This modal just displays the data that's already been fetched

    const columns = [
        {
            title: "Track Title",
            dataIndex: "track_title",
            key: "track_title",
        },
        {
            title: "Period",
            dataIndex: "period",
            key: "period",
            render: (period: string) => {
                try {
                    return dateUtils.defaultFormat(new Date(period));
                } catch {
                    return period;
                }
            },
        },
        {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
        },
        {
            title: "Currency",
            dataIndex: "currency",
            key: "currency",
        },
    ];

    const handleProcess = () => {
        onProcess();
        onCancel();
    };

    return (
        <Modal
            title="Failed to collect earnings from following tracks"
            visible={visible}
            onCancel={onCancel}
            width={800}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button
                    key="process"
                    type="primary"
                    loading={pending as boolean}
                    onClick={handleProcess}
                >
                    Proceed
                </Button>,
            ]}
        >
            <div className="mt-4">
                <Table
                    columns={columns}
                    dataSource={failedShares}
                    rowKey={(record, index) => index?.toString() || "0"}
                    pagination={false}
                    loading={pending as boolean}
                    scroll={{ x: 600, y: 400 }}
                    size="small"
                />
            </div>
        </Modal>
    );
};

export default InvoiceConfirmationModal;
